/**
 * Variant Switch
 * @param {boolean} primaryVariantEnabled If true primaryVariant rendered, if false secondaryVariant rendered
 * @param {FC} primaryVariant Functional Component to be rendered if primaryVariantEnabled: true
 * @param {FC} secondaryVariant Functional Component to be rendered if primaryVariantEnabled: false
 * @param {Props} primaryProps Props to be passed to primaryVariant if primaryVariantEnabled: true
 * @param {Props} secondaryProps Props to be passed to the secondaryVariant if primaryVariantEnabled: false
 */

type VariantSwitchProps<PrimaryProps, SecondaryProps> = React.PropsWithChildren<{
  primaryVariantEnabled: boolean;
  primaryVariant: React.FC<PrimaryProps>;
  secondaryVariant: React.FC<SecondaryProps>;
  primaryProps: PrimaryProps;
  secondaryProps: SecondaryProps;
}>;

export function VariantSwitch<PrimaryProps, SecondaryProps>(props: VariantSwitchProps<PrimaryProps, SecondaryProps>) {
  const {
    children,
    primaryVariant: PrimaryVariant,
    secondaryVariant: SecondaryVariant,
    primaryProps,
    secondaryProps,
    primaryVariantEnabled,
  } = props;

  return (
    <>
      {!!primaryVariantEnabled && typeof PrimaryVariant === 'function' && (
        <PrimaryVariant {...primaryProps}>{children}</PrimaryVariant>
      )}
      {!primaryVariantEnabled && typeof SecondaryVariant === 'function' && (
        <SecondaryVariant {...secondaryProps}>{children}</SecondaryVariant>
      )}
    </>
  );
}
